"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdSetPatchRequestToJSON = exports.AdSetPatchRequestFromJSONTyped = exports.AdSetPatchRequestFromJSON = exports.instanceOfAdSetPatchRequest = void 0;
var runtime_1 = require("../runtime");
var AdSetStatus_1 = require("./AdSetStatus");
var BudgetRequest_1 = require("./BudgetRequest");
var CostModel_1 = require("./CostModel");
var Delivery_1 = require("./Delivery");
var FeatureFlag_1 = require("./FeatureFlag");
var FrequencyCap_1 = require("./FrequencyCap");
var Pacing_1 = require("./Pacing");
var Targets_1 = require("./Targets");
var VideoDeliveryFormat_1 = require("./VideoDeliveryFormat");
/**
 * Check if a given object implements the AdSetPatchRequest interface.
 */
function instanceOfAdSetPatchRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAdSetPatchRequest = instanceOfAdSetPatchRequest;
function AdSetPatchRequestFromJSON(json) {
    return AdSetPatchRequestFromJSONTyped(json, false);
}
exports.AdSetPatchRequestFromJSON = AdSetPatchRequestFromJSON;
function AdSetPatchRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'startTime': !(0, runtime_1.exists)(json, 'start_time') ? undefined : (new Date(json['start_time'])),
        'endTime': !(0, runtime_1.exists)(json, 'end_time') ? undefined : (new Date(json['end_time'])),
        'frequencyCaps': !(0, runtime_1.exists)(json, 'frequency_caps') ? undefined : (new Set(json['frequency_caps'].map(FrequencyCap_1.FrequencyCapFromJSON))),
        'bidMicroAmount': !(0, runtime_1.exists)(json, 'bid_micro_amount') ? undefined : json['bid_micro_amount'],
        'delivery': !(0, runtime_1.exists)(json, 'delivery') ? undefined : (0, Delivery_1.DeliveryFromJSON)(json['delivery']),
        'datasetId': !(0, runtime_1.exists)(json, 'dataset_id') ? undefined : json['dataset_id'],
        'spanFreezeAt': !(0, runtime_1.exists)(json, 'span_freeze_at') ? undefined : (new Date(json['span_freeze_at'])),
        'iasCampaignId': !(0, runtime_1.exists)(json, 'ias_campaign_id') ? undefined : json['ias_campaign_id'],
        'videoDeliveryFormats': !(0, runtime_1.exists)(json, 'video_delivery_formats') ? undefined : (new Set(json['video_delivery_formats'].map(VideoDeliveryFormat_1.VideoDeliveryFormatFromJSON))),
        'category': !(0, runtime_1.exists)(json, 'category') ? undefined : json['category'],
        'categories': !(0, runtime_1.exists)(json, 'categories') ? undefined : json['categories'],
        'budget': !(0, runtime_1.exists)(json, 'budget') ? undefined : (0, BudgetRequest_1.BudgetRequestFromJSON)(json['budget']),
        'costModel': !(0, runtime_1.exists)(json, 'cost_model') ? undefined : (0, CostModel_1.CostModelFromJSON)(json['cost_model']),
        'targets': !(0, runtime_1.exists)(json, 'targets') ? undefined : (0, Targets_1.TargetsFromJSON)(json['targets']),
        'overbooked': !(0, runtime_1.exists)(json, 'overbooked') ? undefined : json['overbooked'],
        'pacing': !(0, runtime_1.exists)(json, 'pacing') ? undefined : (0, Pacing_1.PacingFromJSON)(json['pacing']),
        'rateCardType': !(0, runtime_1.exists)(json, 'rate_card_type') ? undefined : json['rate_card_type'],
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : (0, AdSetStatus_1.AdSetStatusFromJSON)(json['status']),
        'guaranteed': !(0, runtime_1.exists)(json, 'guaranteed') ? undefined : json['guaranteed'],
        'featureFlags': !(0, runtime_1.exists)(json, 'feature_flags') ? undefined : (json['feature_flags'].map(FeatureFlag_1.FeatureFlagFromJSON)),
    };
}
exports.AdSetPatchRequestFromJSONTyped = AdSetPatchRequestFromJSONTyped;
function AdSetPatchRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'start_time': value.startTime === undefined ? undefined : (value.startTime.toISOString()),
        'end_time': value.endTime === undefined ? undefined : (value.endTime.toISOString()),
        'frequency_caps': value.frequencyCaps === undefined ? undefined : (Array.from(value.frequencyCaps).map(FrequencyCap_1.FrequencyCapToJSON)),
        'bid_micro_amount': value.bidMicroAmount,
        'delivery': (0, Delivery_1.DeliveryToJSON)(value.delivery),
        'dataset_id': value.datasetId,
        'span_freeze_at': value.spanFreezeAt === undefined ? undefined : (value.spanFreezeAt.toISOString()),
        'ias_campaign_id': value.iasCampaignId,
        'video_delivery_formats': value.videoDeliveryFormats === undefined ? undefined : (Array.from(value.videoDeliveryFormats).map(VideoDeliveryFormat_1.VideoDeliveryFormatToJSON)),
        'category': value.category,
        'categories': value.categories,
        'budget': (0, BudgetRequest_1.BudgetRequestToJSON)(value.budget),
        'cost_model': (0, CostModel_1.CostModelToJSON)(value.costModel),
        'targets': (0, Targets_1.TargetsToJSON)(value.targets),
        'overbooked': value.overbooked,
        'pacing': (0, Pacing_1.PacingToJSON)(value.pacing),
        'rate_card_type': value.rateCardType,
        'status': (0, AdSetStatus_1.AdSetStatusToJSON)(value.status),
        'guaranteed': value.guaranteed,
        'feature_flags': value.featureFlags === undefined ? undefined : (value.featureFlags.map(FeatureFlag_1.FeatureFlagToJSON)),
    };
}
exports.AdSetPatchRequestToJSON = AdSetPatchRequestToJSON;
